// Overall rubric average + per-criterion horizontal bars, hand-rolled in the
// style of analytics/Charts.tsx (no chart library, CSS-variable colors).

import type { CriterionAvg, RubricCriterion } from "../../services/evals";

function pct(value: number | null): string {
  return value === null ? "—" : `${Math.round(value * 100)}%`;
}

export function scoreTone(value: number | null): string {
  if (value === null) return "";
  if (value >= 0.85) return "good";
  if (value >= 0.6) return "mid";
  return "bad";
}

export function RubricSummary({
  overallAvg,
  count,
  criteria,
  rubric,
}: {
  overallAvg: number | null;
  count: number;
  criteria: CriterionAvg[];
  rubric: RubricCriterion[];
}) {
  if (count === 0) {
    return (
      <div className="state-box">
        No scored calls yet — evaluation runs on a sample of production calls once
        CALL_EVAL_SAMPLE_RATE is above 0, or judge individual calls from the call drawer.
      </div>
    );
  }
  const descriptions = new Map(rubric.map((r) => [r.key, r.description]));
  return (
    <div className="rubric-summary">
      <div className="rubric-overall">
        <span className={`rubric-score ${scoreTone(overallAvg)}`}>{pct(overallAvg)}</span>
        <span className="muted">
          overall rubric average · {count} scored call{count === 1 ? "" : "s"}
        </span>
      </div>
      <div className="rubric-bars">
        {criteria.map((c) => (
          <div className="rubric-bar-row" key={c.key} title={descriptions.get(c.key) || c.key}>
            <span className="rubric-bar-label">{c.key.replaceAll("_", " ")}</span>
            <span className="rubric-bar-track">
              <span
                className={`rubric-bar-fill ${scoreTone(c.avg)}`}
                style={{ width: `${Math.round((c.avg ?? 0) * 100)}%` }}
              />
            </span>
            <span className={`rubric-bar-value ${scoreTone(c.avg)}`}>{pct(c.avg)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
